import { render, staticRenderFns } from "./langManage.vue?vue&type=template&id=1fbe7c9e"
import script from "./langManage.vue?vue&type=script&lang=js"
export * from "./langManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbe7c9e')) {
      api.createRecord('1fbe7c9e', component.options)
    } else {
      api.reload('1fbe7c9e', component.options)
    }
    module.hot.accept("./langManage.vue?vue&type=template&id=1fbe7c9e", function () {
      api.rerender('1fbe7c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/lang/langManage.vue"
export default component.exports